import { createSyncAction } from '@bimser/core';
import { DmParametersFactoryFromJS, IDmParameters } from '../../entities/models/IDmParameters';
import { SET_DM_PARAMETERS_ACTION } from '../actionTypes';

export const setDmParametersAction = (data: IDmParameters) => {
	return createSyncAction(SET_DM_PARAMETERS_ACTION, DmParametersFactoryFromJS(data));
};
